import { IGroupMembers } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export const GetGroupMembers = async (gid: number): Promise<IGroupMembers[]> =>
  provider.Request("/group_players_with_total_experience", { gid });
